import React from 'react'
import { Icon } from '../..'
import SelectFooter, { IPerPageOptions } from '../select-footer'
import {
  Footer,
  ChildrenContainer,
  PaginationContainer,
  SelectContainer,
  PagesContainer,
  PageButton,
  Container,
  ContainerAnimation,
} from './styles'

export type Props = {
  children?: any
  currentPage: number
  pagesTotal: number
  perPage: number
  perPageOptions?: (any & IPerPageOptions)[]
  onPageChange: Function
  onPerPageChange: Function
  animation?: boolean
}

const PaginationTable: React.FC<Props> = (props: Props): JSX.Element => {
  const isFirstPage = props.currentPage === 1
  const isLastPage = props.currentPage === props.pagesTotal

  function generatePageButton(value: number): JSX.Element {
    return (
      <PageButton
        data-qa={`button-${value}`}
        className={value === props.currentPage ? '' : 'inactive'}
        onClick={() => props.onPageChange(value)}
      >
        {value}
      </PageButton>
    )
  }

  function generateDots(): JSX.Element {
    return <span data-qa="span-dots">...</span>
  }

  function getButtons(pagesTotal: number): Array<any> {
    let buttons = []
    const maxPagesDisplayed: number = 8
    if (pagesTotal < maxPagesDisplayed) {
      for (let value = 1; value <= pagesTotal; value++) {
        buttons.push(generatePageButton(value))
      }
      return buttons
    }
    const pagesAfterBreak: number = 2
    const pagesOnLastGroup: number = 5
    const minStartBlock: number = 3
    const pagesPerStep = 1
    const maxFirstblockAmount = 4
    const current: number = props.currentPage
    const penultimate: number = pagesTotal - pagesAfterBreak
    const isFinalPages: boolean = current < penultimate
    const lastGroup: number = pagesTotal - pagesOnLastGroup
    const start: number =
      current <= minStartBlock
        ? pagesPerStep
        : isFinalPages
        ? current - pagesAfterBreak
        : lastGroup
    const end: number =
      current <= minStartBlock
        ? maxFirstblockAmount
        : isFinalPages
        ? current + pagesPerStep
        : penultimate
    for (let value = start; value <= end; value++) {
      buttons.push(generatePageButton(value))
    }
    if (start < lastGroup) buttons.push(generateDots())
    buttons.push(generatePageButton(pagesTotal - pagesPerStep))
    buttons.push(generatePageButton(pagesTotal))

    return buttons
  }

  return (
    <Container>
      {props.animation && <ContainerAnimation />}
      <Footer>
        <ChildrenContainer>{props.children}</ChildrenContainer>
        <PaginationContainer>
          Linhas por página:
          <SelectContainer>
            <SelectFooter
              onPerPageChange={props.onPerPageChange}
              perPage={props.perPage}
              perPageOptions={props.perPageOptions}
            />
          </SelectContainer>
          <PagesContainer>
            <Icon
              data-qa="icon-arrow-left"
              name="chevron_left"
              onClick={
                isFirstPage
                  ? null
                  : () => props.onPageChange(props.currentPage - 1)
              }
              color={
                isFirstPage ? 'neutralColorLowLight' : 'neutralColorLowDark'
              }
            />
            {getButtons(props.pagesTotal).map((button, key) => (
              <div key={key}>{button}</div>
            ))}
            <Icon
              data-qa="icon-arrow-right"
              name="chevron_right"
              onClick={
                isLastPage
                  ? null
                  : () => props.onPageChange(props.currentPage + 1)
              }
              color={
                isLastPage ? 'neutralColorLowLight' : 'neutralColorLowDark'
              }
            />
          </PagesContainer>
        </PaginationContainer>
      </Footer>
    </Container>
  )
}

PaginationTable.defaultProps = {
  perPageOptions: [10, 25, 50],
}

export default PaginationTable
